import React from "react"

const DeviceTenderActiveIcon = () => {
    return (
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 0.899902H3.00002C1.56602 0.899902 0.400024 2.0669 0.400024 3.4999V12.4999C0.400024 13.9339 1.56702 15.0999 3.00002 15.0999H19C20.434 15.0999 21.6 13.9329 21.6 12.4999V3.4999C21.6 2.0659 20.434 0.899902 19 0.899902ZM20.4 12.4999C20.4 13.2719 19.771 13.8999 19 13.8999H3.00002C2.22802 13.8999 1.60002 13.2719 1.60002 12.4999V5.9339H20.4V12.4999ZM20.4 4.7329H1.60002V3.4999C1.60002 2.7279 2.22802 2.0999 3.00002 2.0999H19C19.771 2.0999 20.4 2.7279 20.4 3.4999V4.7329ZM14.4 11.4379C14.4 11.1059 14.669 10.8379 15 10.8379H17C17.331 10.8379 17.6 11.1069 17.6 11.4379C17.6 11.7689 17.331 12.0379 17 12.0379H15C14.669 12.0379 14.4 11.7689 14.4 11.4379Z" fill="#21A6AA" />
        </svg>

    )
}
export default DeviceTenderActiveIcon